import { render, staticRenderFns } from "./ViolationRejectCause.vue?vue&type=template&id=740cc74c&"
import script from "./ViolationRejectCause.vue?vue&type=script&lang=ts&"
export * from "./ViolationRejectCause.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationRejectCause.vue?vue&type=style&index=0&id=740cc74c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports